module.exports = __webpack_public_path__ + "media/images/PSC_logo-8af2dc9cf735fd672ec53a4116aca700.ico";